import { Card, CardContent, Stack } from '@mui/material';
import _ from 'lodash';
import {
  PrimaryLoadingButton,
  PrimaryOutlinedButton,
  WarningButton,
  WarningLoadingButton,
} from '../style/ButtonStyle';
import { FormLabelText } from '../style/TextStyle';
import { CenterModal } from './Modal';
export function ApproveModal({
  on = false,
  title = '',
  children = <></>,
  onClose = _.noop,
  loading = false,
  onConfirm = _.noop,
  confirmText = '확인',
  cancelText = '취소',
  isPrimaryColor = true,
}) {
  return (
    <>
      <CenterModal open={on} onClose={onClose}>
        <Card sx={{ minWidth: '300px' }}>
          <CardContent>
            <Stack alignItems="center">
              <FormLabelText sx={{ fontWeight: 700 }}>{title}</FormLabelText>
            </Stack>
            {children}
            {isPrimaryColor ? (
              <Stack direction="row" justifyContent="space-between" spacing={1}>
                <PrimaryOutlinedButton onClick={onClose}>
                  {cancelText}
                </PrimaryOutlinedButton>
                <PrimaryLoadingButton loading={loading} onClick={onConfirm}>
                  {confirmText}
                </PrimaryLoadingButton>
              </Stack>
            ) : (
              <Stack direction="row" justifyContent="space-between" spacing={1}>
                <WarningButton onClick={onClose}>{cancelText}</WarningButton>
                <WarningLoadingButton loading={loading} onClick={onConfirm}>
                  {confirmText}
                </WarningLoadingButton>
              </Stack>
            )}
          </CardContent>
        </Card>
      </CenterModal>
    </>
  );
}
